<template>
  <div class="exercise-tracking">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg" style="padding-left: 13px;padding-right: 13px;">
          <div class="col-xs-12">
            <h5 class="txt-dark pull-left exerciseTitle">Exercise</h5>
            <router-link to="/exercise/training"
              class="pull-right btn btn-nutri-green ml-10"
            >Personal Training</router-link>
            <a
              href="#"
              class="pull-right btn btn-nutri-green"
              data-toggle="modal"
              data-target="#addExerciseModal"
            >Log Exercise</a>
          </div>
        </div>

        <div class="row mb-20">
					<div class="col-xs-12 col-lg-2 date-picker">
						<p style="font-size:12px;">Date</p>
						<Datepicker inputClass="form-control" v-model="date"></Datepicker>
						<!-- <datetime v-model="date" input-id="start-Date" inputClass="form-control" placeholder="Date">
							<template slot="button-cancel-gd">
								<fa :icon="['far', 'times']"></fa>
								Cancel
							</template>
							<template slot="button-confirm-gd">
								<fa :icon="['fas', 'check-circle']"></fa>
								Confirm
							</template>
						</datetime> -->
					</div>
				</div>

        <!-- /Title -->
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="panel panel-default card-view panel-refresh">
            <div class="refresh-container">
              <div class="la-anim-1"></div>
            </div>
            <div class="panel-heading">
              <div class="pull-left">
                <h6 class="panel-title txt-light">My Exercises</h6>
              </div>
              <div class="clearfix"></div>
            </div>
            <div id="collapse_1" class="panel-wrapper collapse in">
              <div class="panel-body">
                <p
                  v-if="myExercises.data != null && myExercises.data.length == 0"
                >No exercices have been recorded</p>
                <div style="overflow-x:auto;">
                  <table
                    class="table table-responsive"
                    v-if="myExercises.data != null && myExercises.data.length > 0"
                  >
                    <thead>
                      <tr>
                        <th></th>
                        <th>Date</th>
                        <th>Exercise</th>
                        <th class="text-right">Duration in minutes</th>
                        <th class="text-right">Calories Burnt</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(record, index) in myExercises.data" :key="index">
                        <td class="text-center">
                          <img :src="record.image_url" alt style="width:64px;">
                        </td>
                        <td>{{record.date}}</td>
                        <td>
                          {{record.activity_description}} {{record.tracking_details != null ? " at " + JSON.parse(record.tracking_details).average_speed + " minutes per kilometer" : ""}}
                          <br>
                          <span
                            style="font-size:12px; color:#999;"
                          >{{record.activity_specific_motion_description}}</span>
                        </td>
                        <td class="text-right">{{record.duration}}</td>
                        <td class="text-right">{{record.energy_burnt_value}}</td>
                        <td class="text-right">
                          <a
                            href="javascript:void(0)"
                            class="trash"
                            title="Delete"
														data-toggle="modal" 
														@click="temp_id = record.id" 
														data-target="#exampleModal"
                          >
                            <i class="fa fa-trash"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
									<!-- Delete Modal -->
									<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
										<div class="modal-dialog" role="document">
											<div class="modal-content">
											<div class="modal-header">
												<h5 class="modal-title" id="exampleModalLabel">Delete Record</h5>
											</div>
											<div class="modal-body">
												Are you sure you want to delete this exercise record?
											</div>
											<div class="modal-footer">
												<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
												<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="deleteExercise(temp_id)">Okay</button>
											</div>
											</div>
										</div>
									</div>
                </div>
                <div class="row mt-40 text-center" v-if="myExercises.last_page > 1">
                  <ul class="pagination">
                    <li
                      v-for="(value, index) in myExercises.last_page"
                      :key="index"
                      :class="{active:myExercises.current_page == value}"
                    >
                      <a
                        href="javascript:void(0)"
                        @click="viewPage=value; getMyExercises()"
                      >{{value}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Weight Settings Modal -->
        <div
          id="addExerciseModal"
          class="modal fade"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <div class="modal-header-icon">
                  <img src="dist/img/icons/exercise.png" alt="scale">
                  <h4>Log Exercise</h4>
                  <br>
                  <br>
                  <form class="form-horizontal">
                    <div class="form-group">
                      <label for="goal" class="col-sm-3 control-label">Date</label>
                      <div class="col-sm-9">
                        <datepicker input-class="form-control" v-model="newExerciseDate"></datepicker>
                        <!-- <datetime v-model="newExerciseDate" input-id="startDate" inputClass="form-control">
                          <template slot="button-cancel">
                            <fa :icon="['far', 'times']"></fa>
                            Cancel
                          </template>
                          <template slot="button-confirm">
                            <fa :icon="['fas', 'check-circle']"></fa>
                            Confirm
                          </template>
                        </datetime> -->
                      </div>
                    </div>
                    <div class="form-group">
                      <label for class="control-label col-sm-3">Exercise</label>
                      <div class="col-sm-9">
                        <select name id class="form-control" v-model="newExercise" @change="loadSpecificMotions">
                          <option
                            :value="value"
                            v-for="(value, index) in exercises"
                            :key="index"
                          >{{value.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group" v-if="newExercise">
                      <label for class="control-label col-sm-3">Specific Motion</label>
                      <div class="col-sm-9">
                        <select name id class="form-control" v-model="newExerciseSpecificMotion">
                          <option
                            :value="value"
                            v-for="(value, index) in specificMotions"
                            :key="index"
                          >{{value.name}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group" v-if="newExercise">
                      <label for class="control-label col-sm-3">Duration</label>
                      <div class="col-sm-9">
                        <input
                          type="number"
                          class="form-control"
                          v-model="newExerciseDuration"
                          placeholder="in minutes"
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-nutri-red"
                  data-dismiss="modal"
                  ref="newExerciseClose"
                >Close</button>
                <button type="button" class="btn btn-nutri-green" @click="addExercise">Log Exercise</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.modal -->
        <AppFooter></AppFooter>
      </div>
    </div>
    <loading :active.sync="isLoading"></loading>
  </div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter.vue";
import Datepicker from "vuejs-datepicker";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

const api = new API();

export default {
  components: {
    AppHeader,
    AppFooter,
    Datepicker,
    swal,
    Loading,
    Datetime
  },
  data() {
    return {
      isLoading: false,
      newExerciseDate:
        new Date(this.$store.getters.globalDate) != null
          ? new Date(this.$store.getters.globalDate)
          : new Date().data,
      newExercise: null,
      newExerciseSpecificMotion: null,
      newExerciseDuration: null,
      exercises: null,
      specificMotions: null,
      viewPage: 1,
      maxPage: 1,
			myExercises: [],
      temp_id: 0,
      date: this.$store.getters.globalDate,
    };
  },
  watch: {
		'date': function () {
			this.getMyExercises();
		}
  },
  mounted(){
    this.date = this.$store.getters.globalDate;
  },
  methods: {
    addExercise() {
          this.isLoading = true;

      api
        .addExercise(
          this.newExerciseDate,
          this.newExercise.id,
          this.newExerciseSpecificMotion.id,
          this.newExerciseDuration
        )
        .then(async response => {
          swal(
            "Exercise Tracked!",
            "Your exercise has been tracked!",
            "success"
          );
          const elem = this.$refs.newExerciseClose;
          elem.click();
          this.getMyExercises();
        });
    },
    getMyExercises() {
      this.isLoading = true;
      api.getExercisesByDate(this.date).then(async response => {
        if (response.data.success) {
          this.myExercises = response.data.data;
          this.isLoading = false;
        }
      });
    },
    deleteExercise(id) {
      this.isLoading = true;
      api.deleteExercise(id).then(async response => {
        if (response.data.success) {
          this.isLoading = false;
          swal("Exercise Record Deleted!", "", "success");
          this.getMyExercises();
        }
      });
    },
    loadSpecificMotions() {
      console.log(this.newExercise);
      api.getSpecificMotions(this.newExercise.id).then(async response => {
        if (response.data.success) {
          this.isLoading = false;
          this.specificMotions = response.data.data.specific_motions;
        }  
      });
    },
  },
  created: function() {
    this.isLoading = true;
    this.date = this.$store.getters.globalDate;
    this.getMyExercises();
    api.getExercises().then(async response => {
      if (response.data.success) {
        this.isLoading = false;
        this.exercises = response.data.data;
      }
    });
  }
};
</script>


<style scoped>
.date-picker{
		margin-left:10px;
	}

.trash {
  color: rgba(204, 0, 0, 0.5);
}

.trash:hover {
  color: rgba(204, 0, 0, 1);
}

.exerciseTitle {
  margin-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/Exercise/Exercise.vue